import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the checkoutJourney state domain
 */
const selectCheckoutJourneyDomain = state =>
  state.checkoutJourney || initialState;

/**
 * Select the user's choice
 */
const makeSelectChoice = () =>
  createSelector(
    selectCheckoutJourneyDomain,
    substate => substate.choice,
  );

/**
 * Select the platform
 */
const makeSelectPlatform = () =>
  createSelector(
    selectCheckoutJourneyDomain,
    substate => substate.platform,
  );

/**
 * Select the platform options
 */
const makeSelectPlatformOption = () =>
  createSelector(
    selectCheckoutJourneyDomain,
    substate => substate.platformOption,
  );

const makeSelectIntegrationData = () =>
  createSelector(
    selectCheckoutJourneyDomain,
    substate => substate.integrationData,
  );

const makeSelectSteps = () =>
  createSelector(
    selectCheckoutJourneyDomain,
    substate => substate.steps,
  );

const makeSelectLoading = () =>
  createSelector(
    selectCheckoutJourneyDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectCheckoutJourneyDomain,
    substate => substate.error,
  );

export {
  selectCheckoutJourneyDomain,
  makeSelectChoice,
  makeSelectPlatform,
  makeSelectPlatformOption,
  makeSelectIntegrationData,
  makeSelectSteps, 
  makeSelectLoading,
  makeSelectError,
};
